import { Directive, OnInit } from '@angular/core';
import { DxTextBoxComponent } from 'devextreme-angular';

@Directive({
    selector: '[configViewPasswordButton]',
})
export class M4UConfigViewPasswordDirective implements OnInit {

    constructor(private textBox: DxTextBoxComponent) {
    }

    ngOnInit() {
        const button = {
            name: 'viewPassword',
            location: 'after',
            options: {
                icon: 'assets/eye-open.svg',
                elementAttr: { class: 'btn-size-small password-view-btn', style: 'margin:0;' },
                type: 'normal',
                onClick: (e) => {
                    this.textBox.mode = this.textBox.mode === 'text' ? 'password' : 'text';
                    const icon = this.textBox.mode === 'text' ? 'assets/eye-closed.svg' : 'assets/eye-open.svg';
                    e.component.option('icon', icon);
                }
            }
        };
        if (!this.textBox.buttons) {
            this.textBox.buttons = [];
        }
        this.textBox.buttons.unshift(button as any);
    }
}
